import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6">
      <div>
        {eyebrow && (
          <span className="mb-1.5 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-line" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}